import React from 'react';
import MainPage from "../src/components/MainPage"

export default function App() {
  return (
      <React.Fragment>
          <MainPage />
      </React.Fragment>
  );
}